import React from 'react'
import { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import loadCss from "../../common/loadCss";
import loadScript from '../../common/loadScript'
import OwlCarousel from "react-owl-carousel";


function Room(props){
  // const nagative = useNavigate();
  console.log('room', props)
  // const handleBook = ()=>{
  //   console.log('book');
  //   nagative('/hotelBook')
  // }
  return (
    <>
    <div className="row">{/*一列*/}
    <div className="col-12 col-md-5 mb-3 mb-md-0">
    <OwlCarousel className="owl-theme" items={1} loop nav dots={false}>
        {props.Images == null || props.Images.length == 0  ?  (<div className="item">
        <a href="#">
        <img className="img-fluid" src="Flight-Hotel/panelAirR/images/hotel-default.jpg" alt="hotel default" />
        </a>
        </div>) :     (
        props.Images.map((item, index)=> {
          return <div key={index} className="item">
          <a href="#">
          <img className="img-fluid" src={item.Link} alt={item.Description} />
          </a>
          </div>
        })
)
        }
      </OwlCarousel> 
      {/* <div className="owl-carousel owl-theme single-slider owl-loaded owl-drag" data-animateout="fadeOut" data-animatein="fadeIn" data-autoplay data-loop="true" data-autoheight="true" data-nav="true" data-items={1}> */}
        {/* <div className="owl-stage-outer owl-height" style={{height: '309.375px'}}><div className="owl-stage" style={{transform: 'translate3d(-900px, 0px, 0px)', transition: 'all 0s ease 0s', width: '3600px'}}><div className="owl-item cloned" style={{width: '450px'}}><div className="item"><a href="#"><img className="img-fluid" src="images/brands/hotels/hotel-3.jpg" alt="hotels 3" /></a></div></div><div className="owl-item cloned" style={{width: '450px'}}><div className="item"><a href="#"><img className="img-fluid" src="images/brands/hotels/hotel-4.jpg" alt="hotels 4" /></a></div></div><div className="owl-item active" style={{width: '450px'}}><div className="item"><a href="#"><img className="img-fluid" src="images/brands/hotels/hotel-1.jpg" alt="hotels 1" /></a></div></div><div className="owl-item" style={{width: '450px'}}><div className="item"><a href="#"><img className="img-fluid" src="images/brands/hotels/hotel-2.jpg" alt="hotels 2" /></a></div></div><div className="owl-item" style={{width: '450px'}}><div className="item"><a href="#"><img className="img-fluid" src="images/brands/hotels/hotel-3.jpg" alt="hotels 3" /></a></div></div><div className="owl-item" style={{width: '450px'}}><div className="item"><a href="#"><img className="img-fluid" src="images/brands/hotels/hotel-4.jpg" alt="hotels 4" /></a></div></div><div className="owl-item cloned" style={{width: '450px'}}><div className="item"><a href="#"><img className="img-fluid" src="images/brands/hotels/hotel-1.jpg" alt="hotels 1" /></a></div></div><div className="owl-item cloned" style={{width: '450px'}}><div className="item"><a href="#"><img className="img-fluid" src="images/brands/hotels/hotel-2.jpg" alt="hotels 2" /></a></div></div></div></div><div className="owl-nav"><button type="button" role="presentation" className="owl-prev"><i className="fa fa-chevron-left" /></button><button type="button" role="presentation" className="owl-next"><i className="fa fa-chevron-right" /></button></div><div className="owl-dots"><button role="button" className="owl-dot active"><span /></button><button role="button" className="owl-dot"><span /></button><button role="button" className="owl-dot"><span /></button><button role="button" className="owl-dot"><span /></button></div></div> */}
    </div>
    <div className="col-12 col-md-7">
      <h4 className="text-5">{props.selectedRooms.Description}</h4>
      <ul className="list-inline mb-2">
        <li className="list-inline-item"><span className="mr-1 text-black-50"><i className="fas fa-bed" /></span>{props.selectedRooms.Code}</li>
        <li className="list-inline-item"><span className="mr-1 text-black-50"><i className="fas fa-arrows-alt" /></span> 3.66x3.66 sq.mtr</li>
      </ul>
      <div className="row text-1 mb-3">
        <div className="col-6 col-xl-4"><span className="text-success mr-1"><i className="fas fa-check" /></span>Air Conditioning</div>
        <div className="col-6 col-xl-4"><span className="text-success mr-1"><i className="fas fa-check" /></span>Free WiFi</div>
        <div className="col-6 col-xl-4"><span className="text-success mr-1"><i className="fas fa-check" /></span>Television</div>
        <div className="col-6 col-xl-4"><span className="text-success mr-1"><i className="fas fa-check" /></span>Hair Dryer</div>
        <div className="col-6 col-xl-4"><span className="text-success mr-1"><i className="fas fa-check" /></span>Bathtub</div>
        <div className="col-6 col-xl-4"><span className="text-success mr-1"><i className="fas fa-check" /></span>Tea Maker</div>
      </div>
      <div className="d-flex align-items-center">
        <div className="text-dark text-7 line-height-1 font-weight-500 mr-2 mr-lg-3">+$<span style={{fontSize: '3rem', fontWeight: 700}}>
          {props.selectedRooms.Rates && props.selectedRooms.Rates.length > 0 && props.selectedRooms.Rates[0].Sellprice}
          </span></div>
        <span className="text-black-50">per traveler (includes taxes and fees)</span> </div>
      <div className="d-flex align-items-center mt-3"> 
      <a href="#" data-toggle="modal" data-target="#cancellation-policy">Cancellation Policy</a>
      <Link className="btn btn-sm btn-outline-primary shadow-none ml-auto" to="/hotelBook" state={props}>BOOK</Link> 
      {/* <a className="btn btn-sm btn-outline-primary shadow-none ml-auto" onClick={handleBook}></a>  */}
      </div>
    </div>
  </div>
  <hr className="my-4" />
  </>
  )
}

export default function HotelDetail() {
    const location  = useLocation()
    console.log('hotel detail', location)
    useEffect(()=>{
        loadCss('css/MVstyle-2022.css');
        loadCss('font-awesome/css/all.min.css');
        loadCss('css/bootstrap.min.css');
        loadCss('Flight-Hotel/vendor/daterangepicker/daterangepicker.css');
        loadCss('Flight-Hotel/vendor/owl.carousel/assets/owl.carousel.min.css');
        loadCss('Flight-Hotel/vendor/owl.carousel/assets/owl.theme.default.min.css');
        loadCss('css/stylesheet.css');
        loadCss('css/hotelDetail.css');

    },[])
  return (
    <section className="section bg-light shadow-md">
        <div id="content">
          <div className="container-details">
            <div className="row">
              {/* Middle Panel
        ============================================= */}
              <div className="col-lg-12">
                <div className="bg-white shadow-md rounded p-3 p-sm-4 confirm-details">
                  {/*top banneer 三張圖*/}
                  <div className="container-details">
                    <div className="row banner mt-4 mb-2">
                      <div className="col-md-4">
                        <div className="item rounded"> <a href="#">
                            <img className="img-fluid" src="images/brands/hotels/small-banner-13-600x320.jpg" alt="banner" /> </a> </div>
                      </div>
                      <div className="col-md-4 mt-4 mt-md-0">
                        <div className="item rounded"> <a href="#">
                            <img className="img-fluid" src="images/brands/hotels/small-banner-14-600x320.jpg" alt="banner" /> </a> </div>
                      </div>
                      <div className="col-md-4 mt-4 mt-md-0">
                        <div className="item rounded"> <a href="#">
                            <img className="img-fluid" src="images/brands/hotels/small-banner-15-600x320.jpg" alt="banner" /> </a> </div>
                      </div>
                    </div>
                  </div> {/*top banneer 三張圖結束 */} 
                  {/*飯店資訊*/}  
                  <div className="container-details">
                    <div className="theme-item-page-header">
                      <div className="theme-item-page-header-body">
                        <h1 className="theme-item-page-header-title _ff-d _fw-200">{location.state.HotelName}</h1>
                        <div className="theme-item-page-header-rating">
                          <ul className="theme-item-page-header-rating-stars">
                          {location.state.StarRating && Array.from(new Array(parseInt(location.state.StarRating)), (v, i) => i).map((item, index)=>{return <li key={index}><i className="fa fa-star" /></li>})}
                          </ul>
                          <p className="theme-item-page-header-rating-title" style={{lineHeight: '20px'}}>HOTEL ({location.state.HotelID})</p>
                          <p className="theme-breadcrumbs-item-title active">{location.state.HotelAddress}</p>
                          <div fontSize={0} fontWeight="bold" className="View-Map">
                            <i className="fas fa-map-marker-alt" style={{fontSize: '15px', marginRight: '5px'}} /><a href="#">View Map</a></div>
                        </div>
                        <div className="theme-item-page-header-price theme-item-page-header-price-lg">
                          <p className="theme-item-page-header-price-body">
                            <span className="money-symbol">$</span>
                            <span>{location.state.LowPrice}</span>
                          </p><p className="per-person">per person Hotel + Flight</p>
                          <a href="#" className="btn-primary">Choose your room</a>
                        </div>
                        <ul className="theme-breadcrumbs _mt-10 theme-breadcrumbs-default theme-breadcrumbs-sm" style={{lineHeight: '20px'}}>
                          <li>
                            {/*<p class="theme-breadcrumbs-item-title active">Studio 28 Victor Hugo Champs Elysees</p>*/}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>{/*container-details 飯店資訊*/} 
                  <hr className="mb-4" /> 
                  {/******* Tab 開始 *******/}            
                  {/* Tab 選單
        	============================================= */}
                  <nav id="navbar-sticky" className="bg-white pb-2 mb-2 sticky-top smooth-scroll" style={{lineHeight: '22px'}}>
                    <ul className="nav nav-tabs">
                      <li className="nav-item"> <a className="nav-link active text-nowrap" href="#known-for">Overview</a> </li>
                      <li className="nav-item"> <a className="nav-link" href="#choose-room">Choose Room</a> </li>
                      <li className="nav-item"> <a className="nav-link" href="#amenities">Amenities</a> </li>
                      <li className="nav-item"> <a className="nav-link" href="#reviews">Reviews</a> </li>
                      <li className="nav-item"> <a className="nav-link" href="#hotel-policy">Hotel Policy</a> </li>
                    </ul>
                  </nav>{/* Tab 選單 end */}
                  {/* Overview Tab 內容開始
        	============================================= */}
                  <p id="Overview" style={{lineHeight: '1.9'}}>{location.state.Description}</p>
                  <div className="row">
                    <div className="col-12 col-sm-6">
                      <ul className="simple-ul">
                        <li>Libero massa dapibus dui, eu</li>
                        <li>Celerisque nec, rhoncus eget</li>
                        <li>Praesent vitae dui</li>
                        <li>Ut euismod, turpis sollicitudin</li>
                      </ul>
                    </div>
                    <div className="col-12 col-sm-6">
                      <ul className="simple-ul">
                        <li>Libero massa dapibus dui, eu</li>
                        <li>Celerisque nec, rhoncus eget</li>
                        <li>Praesent vitae dui</li>
                        <li>Ut euismod, turpis sollicitudin</li>
                      </ul>
                    </div>
                  </div>
                  <hr />
                  <div className="featured-box style-1">
                    <div className="featured-box-icon text-muted"> <i className="far fa-comments" /></div>
                    <h3 className="font-weight-400 text-4 mb-1">Staff Speaks</h3>
                    <p>English, Hindi, Spanish, Arabic, Russian</p>
                  </div>{/* Overview end */} 
                  <hr className="mb-4" />
                  {/* Choose Room
        	============================================= */}
                  <h2 id="choose-room" className="text-6 mb-4 mt-2">Choose Room</h2>
                  {location.state.Rooms.map((item, index)=>{return <Room key={item.Code} selectedRooms={item} hotelInfo={location.state}/>})}
                  {/* Cancellation Policy Modal */}
                  <div id="cancellation-policy" className="modal fade" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Cancellation Policy</h5>
                          <button type="button" className="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">×</span> </button>
                        </div>
                        <div className="modal-body">
                          <ul>
                            <li>Non-Refundable on cancellation or No Show</li>
                            <li>goCash used in the booking will be non refundable</li>
                            <li>Any Add-on charges are Non-Refundable.</li>
                            <li>You can not change the Check-in or Check-out date.</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>{/* Cancellation Policy Modal end */}
                  {/* Choose Room end */}

                  {/* Amenities
        	============================================= */}
                  <h2 id="amenities" className="text-6 mb-3 mt-2">Amenities</h2>
                  <p className="hotels-amenities-detail text-5"> <span className="border rounded" data-toggle="tooltip" data-original-title="Internet/Wi-Fi"><i className="fas fa-wifi" /></span> <span className="border rounded" data-toggle="tooltip" data-original-title="Restaurant"><i className="fas fa-utensils" /></span> <span className="border rounded" data-toggle="tooltip" data-original-title="Bar"><i className="fas fa-glass-martini" /></span> <span className="border rounded" data-toggle="tooltip" data-original-title="Swimming Pool"><i className="fas fa-swimmer" /></span> <span className="border rounded" data-toggle="tooltip" data-original-title="Business Facilities"><i className="fas fa-chalkboard-teacher" /></span> <span className="border rounded" data-toggle="tooltip" data-original-title="Spa"><i className="fas fa-spa" /></span> <span className="border rounded" data-toggle="tooltip" data-original-title="Gym"><i className="fas fa-dumbbell" /></span> </p>{/* Amenities end */}
                  <hr className="my-4" />
                  {/* Reviews
        	============================================= */}
                  <h2 id="reviews" className="text-6 mb-3 mt-2">Reviews</h2>
                  <div className="row">
                    <div className="col-sm-4 col-md-3">
                      <div id="review-summary" className="bg-primary text-light rounded px-2 py-4 mb-4 mb-sm-0 text-center">
                        <div className="text-10 font-weight-600 line-height-1 d-block">4.5</div>
                        <div className="font-weight-500 my-1">Excellent</div>
                        <small className="d-block">Based on 245 reviews</small> </div>
                    </div>
                    <div className="col-sm-8 col-md-9">
                      <div className="row">
                        <div className="col-8 col-sm-9 col-lg-10">
                          <div className="progress mb-3">
                            <div className="progress-bar" role="progressbar" style={{width: '95%'}} aria-valuenow={95} aria-valuemin={0} aria-valuemax={100} />
                          </div>
                        </div>
                        <div className="col-4 col-sm-3 col-lg-2"><small className="font-weight-600 align-text-top line-height-1">Excellent</small></div>
                      </div>
                      {/* /row */}
                      <div className="row">
                        <div className="col-lg-10 col-9">
                          <div className="progress mb-3">
                            <div className="progress-bar" role="progressbar" style={{width: '85%'}} aria-valuenow={85} aria-valuemin={0} aria-valuemax={100} />
                          </div>
                        </div>
                        <div className="col-lg-2 col-3"><small className="font-weight-600 align-text-top line-height-1">Good</small></div>
                      </div>
                      {/* /row */}
                      <div className="row">
                        <div className="col-lg-10 col-9">
                          <div className="progress mb-3">
                            <div className="progress-bar" role="progressbar" style={{width: '60%'}} aria-valuenow={60} aria-valuemin={0} aria-valuemax={100} />
                          </div>
                        </div>
                        <div className="col-lg-2 col-3"><small className="font-weight-600 align-text-top line-height-1">Fair</small></div>
                      </div>
                      {/* /row */}
                      <div className="row">
                        <div className="col-lg-10 col-9">
                          <div className="progress mb-3">
                            <div className="progress-bar" role="progressbar" style={{width: '25%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
                          </div>
                        </div>
                        <div className="col-lg-2 col-3"><small className="font-weight-600 align-text-top line-height-1">Poor</small></div>
                      </div>
                      {/* /row */}
                      <div className="row">
                        <div className="col-lg-10 col-9">
                          <div className="progress mb-3">
                            <div className="progress-bar" role="progressbar" style={{width: 0}} aria-valuenow={0} aria-valuemin={0} aria-valuemax={100} />
                          </div>
                        </div>
                        <div className="col-lg-2 col-3"><small className="font-weight-600 align-text-top line-height-1">Bad</small></div>
                      </div>
                      {/* /row */} 
                    </div>
                  </div>
                  <hr className="mb-4" />
                  <div className="row">
                    <div className="col-12 col-sm-3 text-center">
                      <div className="review-tumb bg-dark-5 text-light rounded-circle d-inline-block mb-2 text-center text-8">R</div>
                      <p className="mb-0 line-height-1">Ruby Clinton</p>
                      <small><em>Jan 25, 2019</em></small> </div>
                    <div className="col-12 col-sm-9 text-center text-sm-left"> <span className="text-2"> <i className="fas fa-star text-warning" /> <i className="fas fa-star text-warning" /> <i className="fas fa-star text-warning" /> <i className="fas fa-star text-warning" /> <i className="fas fa-star text-muted opacity-4" /> </span>
                      <p className="font-weight-600 mb-1">Excellent hotel with great location</p>
                      <p>We stayed in this hotel for one night and were happy that we booked this hotel. Location is excellent and hotel has a lovely ambience . Rooms are very spacious with a decent decor. Overall experience was good.</p>
                      <hr />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-3 text-center">
                      <div className="review-tumb text-light rounded-circle d-inline-block mb-2 text-center text-8"> <img className="rounded-circle" alt="" src="../新增資料夾/quickai-recharge-billpayment-booking-html5-template-2.1/HTML/images/brands/hotels/tumb.jpg" /> </div>
                      <p className="mb-0 line-height-1">James Maxwell</p>
                      <small><em>Dec 19, 2018</em></small> </div>
                    <div className="col-12 col-sm-9 text-center text-sm-left"> <span className="text-2"> <i className="fas fa-star text-warning" /> <i className="fas fa-star text-warning" /> <i className="fas fa-star text-warning" /> <i className="fas fa-star text-warning" /> <i className="fas fa-star text-warning" /> </span>
                      <p className="font-weight-600 mb-1">Safe for Family &amp; Good service</p>
                      <p>It was a nice experience the hotel was neat and clean. Good location nice staffs. food items specially Curry needs to be more tastier. this is my third stay in this hotel. great experience, Safe for Family.</p>
                      <hr />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-sm-3 text-center">
                      <div className="review-tumb bg-dark-5 text-light rounded-circle d-inline-block mb-2 text-center text-8">N</div>
                      <p className="mb-0 line-height-1">Neil Patel</p>
                      <small><em>Nov 03, 2018</em></small> </div>
                    <div className="col-12 col-sm-9 text-center text-sm-left"> <span className="text-2"> <i className="fas fa-star text-warning" /> <i className="fas fa-star text-warning" /> <i className="fas fa-star text-warning" /> <i className="fas fa-star text-muted opacity-4" /> <i className="fas fa-star text-muted opacity-4" /> </span>
                      <p className="font-weight-600 mb-1">Staff is very helpful but rooms are bit small</p>
                      <p>Staff is very helpful and courteous but rooms are bit small, smelly and you have to share your stay with cockroaches.</p>
                      <hr />
                    </div>
                  </div>
                  <div className="text-center"> <a href="#" className="btn btn-sm btn-outline-dark shadow-none">view more reviews</a> </div>
                  {/*<h5 class="mb-3 mt-2">Write a review</h5>
            <form>
              <div class="form-group">
                <label for="yourName">Your Name</label>
                <input type="email" class="form-control" id="yourName" required aria-describedby="yourName" placeholder="Enter your name">
              </div>
              <div class="form-group">
                <label for="yourReview">Your Review</label>
                <textarea class="form-control" rows="5" id="yourReview" required placeholder="Enter Your Review"></textarea>
              </div>
              <div class="form-group">
                <label>Rating</label>
                <div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input id="bad" name="reviewRating" class="custom-control-input" checked="" required type="radio">
                    <label class="custom-control-label" for="bad">Bad</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input id="poor" name="reviewRating" class="custom-control-input" checked="" required type="radio">
                    <label class="custom-control-label" for="poor">Poor</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input id="fair" name="reviewRating" class="custom-control-input" checked="" required type="radio">
                    <label class="custom-control-label" for="fair">Fair</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input id="good" name="reviewRating" class="custom-control-input" checked="" required type="radio">
                    <label class="custom-control-label" for="good">Good</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input id="excellent" name="reviewRating" class="custom-control-input" checked="" required type="radio">
                    <label class="custom-control-label" for="excellent">Excellent</label>
                  </div>
                </div>
              </div>
              <button type="submit" class="btn btn-primary">Submit</button>
            </form>*/}{/* Reviews end */}
                  <hr className="my-4" />
                  {/* Hotel Policy
        	============================================= */}
                  <h2 id="hotel-policy" className="text-6 mb-3 mt-2">Hotel Policy</h2>
                  <p>The standard check-in time is 12:00 PM and the standard check-out time is 11:00 AM. Early check-in or late check-out is strictly subjected to availability and may be chargeable by the hotel. Any early check-in or late check-out request must be directed and reconfirmed with hotel directly, Accommodation, 24 hours House Keeping, Hot and Cold water available, Internet, Telephone.</p>
                  <p>Hotel Policy: Most hotels do not allow unmarried/unrelated couples to check-in. This is at the full discretion of the hotel management. No refund would be applicable in case the hotel denies check-in under such circumstances., Most hotels do not allow same city/local ID Proofs for check-in. Kindly check with your hotel about the same before checking in. This is at full discretion of the hotel management. No refund would be applicable in case the hotel denies check-in under such circumstances.</p>
                  {/* Hotel Policy end */}
                </div>
              </div>{/* Middle Panel End*/} 
              {/* Side Panel
        ============================================= */}
              {/* Side Panel End */} 
            </div>
          </div>
        </div>	
      </section>
  )
}
